module.exports = __webpack_public_path__ + "img/csv.24590a2d.svg";